import type { ThemeKey } from './themeKeys';

export interface ScheduleEntry {
  startHour: number;
  theme: ThemeKey;
}

/**
 * Ordered ascending by startHour. Wraps midnight: any hour before the first
 * entry resolves to the last entry's theme.
 */
export const DEFAULT_SCHEDULE: ReadonlyArray<ScheduleEntry> = [
  { startHour: 4, theme: 'pre-dawn' },
  { startHour: 9, theme: 'morning' },
  { startHour: 12, theme: 'day' },
  { startHour: 17, theme: 'evening' },
  { startHour: 20, theme: 'late-evening' },
  { startHour: 23, theme: 'night' },
];

export function resolveScheduledTheme(now: Date, schedule: ReadonlyArray<ScheduleEntry> = DEFAULT_SCHEDULE): ThemeKey {
  const hour = now.getHours();
  let resolved = schedule[schedule.length - 1].theme;
  for (const entry of schedule) {
    if (entry.startHour <= hour) {
      resolved = entry.theme;
    }
  }
  return resolved;
}
